module.exports = __webpack_public_path__ + "img/s00141.bfa6e48d.png";